import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import 'flowbite';
import './index.css'
import "../public/videojs/mockup/videojs.min.css"
import Toast from 'vue-toastification'
import 'maz-ui/styles' // or import 'maz-ui/css/main.css'

import 'vue-toastification/dist/index.css'
import './index.css'
import * as Sentry from "@sentry/vue";
const options = { 
    timeout: 5000,
    position: 'top-center',
    closeOnClick: true,
    showCloseButtonOnHover: true,
    pauseOnHover: true,
    containerClassName: 'custom-toast-container',
};
const pinia = createPinia()

router.afterEach((to) => {
  document.title = to.meta.title || 'ناسنا | مننا ولينا'
});

const app = createApp(App);
Sentry.init({
  app,
  dsn: "https://99b71acf2c3a74a26dec9d845d73202a@o4510510842839040.ingest.us.sentry.io/4510515414302720",    
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration()
  ],
  tracesSampleRate: 1.0, 
   tracePropagationTargets: ["localhost", /^https:\/\/api.nasna\.tv\/api/],
  replaysSessionSampleRate: 0.1, 
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true
});


app.use(pinia).use(Toast, options).use(router).mount('#app')
